import { render, staticRenderFns } from "./QuestionGapFilling.vue?vue&type=template&id=7a1f6981&scoped=true"
import script from "./QuestionGapFilling.vue?vue&type=script&lang=js"
export * from "./QuestionGapFilling.vue?vue&type=script&lang=js"
import style0 from "./QuestionGapFilling.vue?vue&type=style&index=0&id=7a1f6981&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1f6981",
  null
  
)

export default component.exports